module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom de l'opération")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operation.name),
      expression: "operation.name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.operation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operation, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label no-border",
    class: {
      error: _vm.errors.has('client')
    }
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('custom-select-user', {
    attrs: {
      "items": _vm.clients,
      "disabled": _vm.missionExist
    },
    model: {
      value: (_vm.operation.client),
      callback: function($$v) {
        _vm.$set(_vm.operation, "client", $$v)
      },
      expression: "operation.client"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('client')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('contrat')
    }
  }, [_c('label', {
    attrs: {
      "for": "contrat"
    }
  }, [_vm._v("ID Client")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "ref_client",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.operation.client ? '#' + _vm.operation.client.id : ''
    }
  })]), _vm._v(" "), (_vm.errors.has('contrat')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('contrat')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('montant')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operation.amount.value),
      expression: "operation.amount.value"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.operation.amount.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operation.amount, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.operation.amount.currency),
      callback: function($$v) {
        _vm.$set(_vm.operation.amount, "currency", $$v)
      },
      expression: "operation.amount.currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('montant')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('montant')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-textarea",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operation.description),
      expression: "operation.description"
    }],
    attrs: {
      "name": "description"
    },
    domProps: {
      "value": (_vm.operation.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operation, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row start"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'TransactionsTable'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-gold"
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.saveOperation
    }
  }, [_vm._v("\n\t\t\tEnregistrer\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c579590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MyTransactions/EditForm/Main.vue
// module id = 1145
// module chunks = 0